<script lang="ts">
	import { isDarkMode } from '$lib/stores/dark-mode';
	import { businessTimezone, t } from '$lib/stores/i18n';
	import ReservatooLogo from '$lib/svg/reservatooLogo.svg.svelte';
	import { getWidgetBackgroundContrastHexColor } from '$lib/widget/helper/widget';
	import { widgetColors, widgetContent } from '$lib/widget/stores';
	import { onMount } from 'svelte';

	$businessTimezone = $widgetContent?.business?.timezone;

	let logoColor = $state('#000000');
	function updateLogoOnColorSchemeChange(isDarkMode: boolean) {
		logoColor = getWidgetBackgroundContrastHexColor($widgetColors);
	}
	onMount(() => {
		updateLogoOnColorSchemeChange(false);
	});
	$effect(() => {
		$widgetColors && updateLogoOnColorSchemeChange($isDarkMode);
	});
</script>

<footer
	class="w-fit mx-auto text-sm flex items-center gap-0.5 justify-center py-2 mt-8
						bg-widget-background text-widget-background-on
						dark:bg-widget-background-dark dark:text-widget-background-dark-on
						transform transition-transform duration-300 hover:scale-105
						"
>
	{$t('widget-external.powered_by')}
	<a href="https://www.reservatoo.com/?ref=widget" target="_blank">
		<ReservatooLogo className="h-5" color={logoColor} />
	</a>
</footer>
